// /src/pages/DashboardReports.js
import React, { useState } from "react";
import { useEffect } from "react";
import WagesReport from "../reports/WagesReport";
import ProfitLossReport from "../reports/ProfitLossReport";
import WastageReport from "../reports/WastageReport";
import CashReceivedReport from "../reports/CashReceivedReport";
import CardTransactionsReport from "../reports/CardTransactionsReport";
import SnappyDeliveriesReport from "../reports/SnappyDeliveriesReport";
import SupplierPaymentsReport from "../reports/SupplierPaymentsReport";
import ExpensesReport from "../reports/ExpensesReport";
import DebtsReport from "../reports/DebtsReport";
import StocktakeReport from "../reports/StocktakeReport";
import MoneyFlowReport from "../reports/MoneyFlowReport";
import { supabase } from "./supabaseClient";

export default function DashboardReports() {
  // Default date range = last 7 days
  const today = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 7);

  const [fromDate, setFromDate] = useState(
    sevenDaysAgo.toISOString().split("T")[0]
  );
  const [toDate, setToDate] = useState(today.toISOString().split("T")[0]);

  const [selectedReport, setSelectedReport] = useState("wages");
  const [employee, setEmployee] = useState("All");

  // HOURLY RATE → Global so both Wages & P&L can use it
  const [hourlyRate, setHourlyRate] = useState(9.5);

  const [viewType, setViewType] = useState("daily");

  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    async function fetchEmployees() {
      const { data, error } = await supabase
        .from("employees")
        .select("full_name")  // use full_name to match Clockins
        .order("full_name", { ascending: true });

      if (!error && data) {
        setEmployees(data.map((e) => e.full_name));
      }
    }
    fetchEmployees();
  }, []);

  // Render selected report
  const renderReport = () => {
    const commonProps = { fromDate, toDate };

    switch (selectedReport) {
      case "wages":
        return (
          <WagesReport
            {...commonProps}
            employee={employee}
            hourlyRate={hourlyRate}
            viewType={viewType}
          />
        );
      case "profitLoss":
        return (
          <ProfitLossReport
            {...commonProps}
            hourlyRate={hourlyRate} // ✅ pass hourlyRate to P&L
          />
        );
      case "wastage":
        return <WastageReport {...commonProps} />;
      case "cashReceived":
        return <CashReceivedReport {...commonProps} />;
      case "cardTransactions":
        return <CardTransactionsReport {...commonProps} />;
      case "snappyDeliveries":
        return <SnappyDeliveriesReport {...commonProps} />;
      case "supplierPayments":
        return <SupplierPaymentsReport {...commonProps} />;
      case "expenses":
        return <ExpensesReport {...commonProps} />;
      case "debts":
        return <DebtsReport {...commonProps} />;
      case "stocktake":
        return <StocktakeReport {...commonProps} />;
         case "moneyflow":
        return <MoneyFlowReport {...commonProps} />;
      default:
        return null;
    }
  };

  return (
  <div className="main-content" style={{ maxWidth: 1200, margin: "24px auto", padding: "0 16px" }}>
    <h2 className="h2">📊 Dashboard</h2>

    {/* Filters */}
    <div className="card filters-card" style={{ marginBottom: 16 }}>
      <fieldset>
        <legend className="section-title">🔍 Filters</legend>

        <div className="filters-row">
          <div>
            <label>From</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div>
            <label>To</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div>
            <label>Select Report</label>
            <select
              value={selectedReport}
              onChange={(e) => setSelectedReport(e.target.value)}
            >
              <option value="wages">Wages & Salary Report</option>
              <option value="profitLoss">Profit & Loss</option>
              <option value="wastage">Wastage Report</option>
              <option value="cashReceived">Total Cash Received</option>
              <option value="cardTransactions">Total Card Transactions</option>
              <option value="snappyDeliveries">Snappy Deliveries</option>
              <option value="supplierPayments">Supplier Payments</option>
              <option value="expenses">Expenses Breakdown</option>
              <option value="debts">Debts & Liabilities</option>
              <option value="stocktake">Stocktake Variance</option>
              <option value="moneyflow">Money Flow Report</option>
            </select>
          </div>
        </div>
      </fieldset>
    </div>

    {/* Extra Filters for Wages */}
    {selectedReport === "wages" && (
      <div className="card" style={{ marginBottom: 16 }}>
        <fieldset>
          <legend className="section-title">👤 Wages Filters</legend>

          <div className="filters-row">
            <div>
              <label>Employee</label>
              <select
                value={employee}
                onChange={(e) => setEmployee(e.target.value)}
              >
                <option value="All">All</option>
                {employees.map((emp) => (
                  <option key={emp} value={emp}>
                    {emp}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label>Hourly Rate (£)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={hourlyRate}
                onChange={(e) => setHourlyRate(parseFloat(e.target.value))}
              />
            </div>

            <div>
              <label>View Type</label>
              <select
                value={viewType}
                onChange={(e) => setViewType(e.target.value)}
              >
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
              </select>
            </div>
          </div>
        </fieldset>
      </div>
    )}

    {/* Report Output */}
    <div className="card" style={{ overflowX: "auto" }}>
      {renderReport()}
    </div>
  </div>
);

}
